<template>
  <div
    class="a-section-meta mb-7"
    :class="{ '-has-image': hasImage }"
  >
    <div
      v-if="hasImage"
      class="a-section-meta__item"
    >
      <base-image
        v-if="item.image && item.image[0]"
        :url="item.image[0].url"
        :width="440"
        :height="500"
        :ratio="500/440"
        :alt-text="item.headline"
        class="a-section-meta__figure"
        image-class="a-section-meta__image"
      />
      <div class="a-section-meta__overlay">
        <h3 v-if="item.headline" class="a-section-meta__headline">
          {{ item.headline }}
        </h3>
        <div v-if="item.text" class="a-section-meta__text" v-html="item.text" />
      </div>
    </div>
    <div v-else class="a-section-meta__item">
      <h3 class="a-section-meta__headline">
        {{ item.headline }}
      </h3>
      <div class="a-section-meta__text" v-html="item.text" />
    </div>
  </div>
</template>

<script>
import BaseImage from '@/components/atoms/BaseImage';
export default {
  name: 'SectionMeta',
  components: {
    BaseImage
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    hasImage () {
      return this.item.image && this.item.image[0];
    }
  }
}
</script>